import Footer from "../components/Footer";
import Navbar from "../components/navbar";
import { useSelector } from "react-redux";
import React, { useEffect } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { useDispatch } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";

// ---------------------- Sidebars ---------------------------
import ProfileInfo from "../pages/Sidebar/Profileinfo";
import ProfileinfoUpdate from "../pages/Sidebar/ProfileinfoUpdate";
import Menu from "../pages/Sidebar/Menu";

// ----------- Subscription
import Subscription from "../pages/Sidebar/Subscription";
import PreviousBills from "../pages/Sidebar/PreviousBills";
import UpgradeSubscription from "../pages/Sidebar/UpgradeSubscription";
import SubscriptionCancel from "../pages/Sidebar/SubscriptionCancel";

// --------------- Good Read
import GoodRead from "../pages/Sidebar/GoodRead";

// ---------- Setting
import SettingsMenu from "../pages/Sidebar/SettingsMenu";
import LinkDevice from "../pages/Sidebar/LinkDevice";
import Allergens from "../pages/Sidebar/Allergens";
import MealPreferences from "../pages/Sidebar/MealPreferences";
import WorkPreferences from "../pages/Sidebar/WorkPreferences";
import FastingPreferences from "../pages/Sidebar/FastingPreferences";
import Reset from "../pages/Sidebar/Reset";
import Logout from "../pages/Sidebar/Logout";

// ---------- Help Center
import Faq from "../pages/Sidebar/Faq";

// ----------- Notifications
import Notifications from "../pages/Sidebar/Notifications";

// ---------- Help Center
import HelpCenter from "../pages/Sidebar/HelpCenter";

// ---------- About
import About from "../pages/Sidebar/About";
import AboutUs from "../pages/Sidebar/AboutUs";
import Privacy from "../pages/Sidebar/Privacy";
import Terms from "../pages/Sidebar/Terms";
import Refund from "../pages/Sidebar/Refund";
import MainMobileMenu from "../pages/Sidebar/MainMobileMenu";
import SupportForm from "../pages/Sidebar/SupportForm";
import Chatbot from "../pages/Sidebar/Chatbot";
import MoodsView from "../pages/Sidebar/MoodsView";
import SpecificDiet from "../pages/Sidebar/SpecificDiet";
import AllergyPrefrences from "../pages/Sidebar/AllergyPrefrences";

const MainBg = ({ children }) => {
  const { drawerActiveMenu, isDrawerActive } = useSelector(
    (state) => state.webUtilities
  );
  const dispatch = useDispatch();

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(null));
    await dispatch(setIsDrawerActive(false));
    secureLocalStorage.removeItem("backMenu");
  };
  useEffect(() => {
    // console.log(isDrawerActive)
  }, [isDrawerActive]);

  return (
    <div className="manlay">
      <Navbar />
      <div className="bodyly_large mt-[70px]">
        {children}
        <Footer />
      </div>
      <Drawer
        open={isDrawerActive}
        direction="right"
        lockBackgroundScroll={true}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        style={{
          width: "",
          backgroundImage:
            drawerActiveMenu === 311
              ? "url(/images/linker/bg.png)"
              : drawerActiveMenu === 312
              ? "url(/images/allergies/bg.png)"
              : drawerActiveMenu === 313 || drawerActiveMenu === 317
              ? "url(/images/mealPreferences/bg.png)"
              : drawerActiveMenu === 6
              ? "url(/images/mealPreferences/bg.png)"
              : "none",
          backgroundSize: "cover",
        }}
        onClose={handleCloseDrawer}
      >
        {drawerActiveMenu === 1 && <ProfileInfo />}
        {drawerActiveMenu === 2 && <ProfileinfoUpdate />}
        {drawerActiveMenu === 3 && <Menu />}
        {drawerActiveMenu === 4 && <Notifications />}
        {drawerActiveMenu === 5 && <MainMobileMenu />}
        {drawerActiveMenu === 6 && <MoodsView />}
        {/* drawerActiveMenu===7 is reserve for Meals */}

        {/* Setting Menus */}
        {drawerActiveMenu === 31 && <SettingsMenu />}
        {/* ---- option----- */}
        {drawerActiveMenu === 311 && <LinkDevice />}
        {drawerActiveMenu === 312 && <Allergens />}
        {drawerActiveMenu === 313 && <MealPreferences />}
        {drawerActiveMenu === 314 && <WorkPreferences />}
        {drawerActiveMenu === 315 && <FastingPreferences />}
        {drawerActiveMenu === 316 && <Reset />}
        {drawerActiveMenu === 317 && <Logout />}
        {drawerActiveMenu === 318 && <SpecificDiet />}
        {drawerActiveMenu === 319 && <AllergyPrefrences />}

        {/* Subscription */}
        {drawerActiveMenu === 32 && <Subscription />}
        {drawerActiveMenu === 321 && <PreviousBills />}
        {drawerActiveMenu === 322 && <UpgradeSubscription />}
        {drawerActiveMenu === 323 && <SubscriptionCancel />}

        {/* Good Read */}
        {drawerActiveMenu === 33 && <GoodRead />}

        {/* Help Center */}
        {drawerActiveMenu === 34 && <HelpCenter />}
        {drawerActiveMenu === 341 && <Faq />}
        {drawerActiveMenu === 342 && <SupportForm />}
        {drawerActiveMenu === 343 && <Chatbot />}

        {/* About Us */}
        {drawerActiveMenu === 35 && <About />}
        {drawerActiveMenu === 351 && <AboutUs />}
        {drawerActiveMenu === 352 && <Privacy />}
        {drawerActiveMenu === 353 && <Terms />}
        {drawerActiveMenu === 354 && <Refund />}

        {/* Mood page  */}
        {/* Mood page  */}
      </Drawer>
    </div>
  );
};
export default MainBg;
